import { Alert, Button } from 'react-bootstrap';
import React, { useCallback, useEffect, useState } from 'react';

import LoadingSpinner from '../../../components/LoadingSpinner';
import { Logo } from '../../../assets';
import classNames from 'classnames';
import styles from './Unauthorized.module.scss';
import { useAuth } from 'oidc-react';
import { useLocation } from 'react-router-dom';

export default function UnauthorizedIndex() {
  const auth = useAuth();

  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setLoading(false);
  }, [location.pathname]);

  useEffect(() => {
    const handlePageShow = () => {
      setLoading(false);
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  const onClick = useCallback(async () => {
    setError(null);
    setLoading(true);
    try {
      await auth.signIn();
    } catch (err: unknown) {
      if (err instanceof Error) {
        setError(err);
        setLoading(false);
      }
    }
  }, [auth]);

  function renderError() {
    if (!error) {
      return null;
    }
    return <Alert variant="danger">{error.message}</Alert>;
  }

  return (
    <div className="h-100 d-flex flex-column flex-md-row">
      <div className={classNames(styles.section, styles.leftLogin)}>
        <img className="w-75" src={Logo} alt="Côntrol Portal" />
      </div>
      <div className={styles.section}>
        <h1 className="fw-bold mb-4">Sign in to your portal account</h1>
        {renderError()}
        <Button onClick={onClick} disabled={loading} size="lg">
          {loading ? (
            <>
              <LoadingSpinner
                className={styles.loading}
                isButtonSpinner={true}
              />{' '}
              Loading
            </>
          ) : (
            'Sign In'
          )}
        </Button>
      </div>
    </div>
  );
}
